<template>
    <div class="not-found">
        <h1>Eroare 404!</h1>
        <p>N-am putut găsi pagina pe care ai cerut-o. Ești sigur că ai introdus corect link-ul?</p>
    </div>
</template>

<script>

export default {
    name: 'NotFound',
}
</script>

<style scoped>
.not-found {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: grey;
    padding: 20px;
    text-align: center;
}

h1 {
    font-size: 7rem;
}

p {
    font-size: 2rem;
}
</style>
